// extracted by mini-css-extract-plugin
export default {"brandButton":"Wave_brandButton__plmJc","getStartedButton":"Wave_getStartedButton__akboB","wave":"Wave_wave__AyOXA"};